const isEmpty = (value) => value === undefined
  || value === null
  || value === ''
  || (Array.isArray(value) && value.length === 0);

export { isEmpty };
